import { FormatDateComponentModule } from '@b2b/common/components/format-date';
import { FormatTimeComponentModule } from '@b2b/common/components/format-time';
import { input } from '@b2b/types/core';
import { WillCallOrderItemsByEventVo } from '@b2b/types/order/api/will-call-order-detail.type';
import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

class OrderEventHeaderController {
  static $inject = ['$element', 'CalendarService', 'HelpersService'];

  event = input<WillCallOrderItemsByEventVo>();
  eventCapacity = input<number>(0);

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-order-event-header');
  }
}

export const OrderEventHeaderComponentModule = angular
  .module('acme.view.application.orders.edit.components.order-event-header', [
    uiRouter,
    FormatDateComponentModule,
    FormatTimeComponentModule,
  ])
  .component('acmeOrderEventHeader', {
    templateUrl: `views/application/views/orders/edit/components/order-event-header/order-event-header.component.tpl.html`,
    controller: OrderEventHeaderController,
    controllerAs: '$ctrl',
    bindings: {
      event: '<',
      eventCapacity: '<',
    },
  }).name;
